import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

export default function SectionBooking1({ _data }) {
	const navigate = useNavigate();
	const [trackingRef, setTrackingRef] = useState('');

	const handleTrack = (e) => {
		e.preventDefault();
		if (trackingRef.trim()) {
			navigate(`/track-shipment?ref=${encodeURIComponent(trackingRef.trim())}`);
		}
	};

	return (
		<div
			className='section-full p-t120 p-b90 site-bg-gray tw-booking-area tw-booking-area-bg-wrap'
			style={{ backgroundImage: `url(${_data.background})` }}
		>
			<div
				className='tw-booking-area-bg'
				style={{ backgroundImage: `url(${_data.imageBack})` }}
			></div>

			<div className='container'>
				{/* <!-- TITLE START--> */}
				<div className='section-head center wt-small-separator-outer'>
					<div className='wt-small-separator site-text-primary'>
						<div>{_data.title}</div>
					</div>
					<h2 className='wt-title'>{_data.subtitle}</h2>
					<p className='section-head-text'>{_data.description}</p>
				</div>
				{/* <!-- TITLE END--> */}
			</div>

			<div className='container'>
				<div className='tw-booking-section'>
					<div className='row'>
						<div className='col-xl-3 col-lg-3 col-md-12'>
							<div className='tw-booking-media'>
								<div className='media'>
									<img src={_data.image} alt='#' />
								</div>
							</div>
						</div>

						<div className='col-xl-9 col-lg-9 col-md-12'>
							<div className='tw-booking-form'>
								<div className='row booking-tab-container'>
									<div className='col-lg-2 col-md-2 booking-tab-menu'>
										<div className='list-group'>
											<button className='list-group-item active text-center'>
												<div className='media'>
													<img src={_data.form.quote} alt='#' />
												</div>
												<span>Request A Quote</span>
											</button>
											{/* <button className='list-group-item text-center'>
												<div className='media'>
													<img src={_data.form.track} alt='#' />
												</div>
												<span>Track</span>
											</button> */}
										</div>
									</div>
									<div className='col-lg-10 col-md-10 booking-tab mt-4 lg-mt-0'>
										{/* <!-- flight section --> */}
										<div className='booking-tab-content active'>
											<form className='booking-form' id='booking-form'>
												<div className='row'>
													<div className='col-lg-4 col-md-4'>
														<div className='mb-3'>
															<input
																name='username'
																type='text'
																required
																className='form-control'
																placeholder='Name'
															/>
														</div>
													</div>
													<div className='col-lg-4 col-md-4'>
														<div className='mb-3'>
															<input
																name='email'
																type='text'
																required
																className='form-control'
																placeholder='Email'
															/>
														</div>
													</div>
													<div className='col-lg-4 col-md-4'>
														<div className='mb-3'>
															<input
																name='phone'
																type='text'
																required
																className='form-control'
																placeholder='Phone'
															/>
														</div>
													</div>

													<div className='col-lg-12 col-md-12'>
														<div className='mb-3'>
															<input
																name='username'
																type='text'
																required
																className='form-control'
																placeholder='City Of Departure'
															/>
														</div>
													</div>

													<div className='col-lg-12 col-md-12'>
														<div className='mb-3'>
															<input
																name='username'
																type='text'
																required
																className='form-control'
																placeholder='Delivery City'
															/>
														</div>
													</div>

													<div className='col-lg-3 col-md-3'>
														<div className='mb-3'>
															<input
																name='username'
																type='text'
																required
																className='form-control'
																placeholder='Weight'
															/>
														</div>
													</div>
													<div className='col-lg-3 col-md-3'>
														<div className='mb-3'>
															<input
																name='email'
																type='text'
																required
																className='form-control'
																placeholder='Height'
															/>
														</div>
													</div>
													<div className='col-lg-3 col-md-3'>
														<div className='mb-3'>
															<input
																name='phone'
																type='text'
																required
																className='form-control'
																placeholder='Width'
															/>
														</div>
													</div>
													<div className='col-lg-3 col-md-3'>
														<div className='mb-3'>
															<input
																name='phone'
																type='text'
																required
																className='form-control'
																placeholder='Length'
															/>
														</div>
													</div>

													<div className='col-lg-12 col-md-12'>
														<div className='tw-booking-footer'>
															<div className='tw-booking-footer-btn'>
																<button
																	type='button'
																	className='btn-half site-button'
																	onClick={() => {
																		const id = toast.loading('Loading...');
																		setTimeout(() => {
																			toast.update(id, {
																				render:
																					"Submitted successfully. We'll reach out to you soon!",
																				type: 'success',
																				isLoading: false,
																				autoClose: 3000,
																				closeOnClick: true,
																			});
																			document
																				.getElementById('booking-form')
																				.reset();
																		}, 2000);
																		// reset the form
																	}}
																>
																	<span>Submit Now</span>
																	<em></em>
																</button>
															</div>
															<span className='tw-booking-footer-text'>
																Quote
															</span>
														</div>
													</div>
												</div>
											</form>
										</div>
										{/* <!-- track section --> */}
										{/* <div className='booking-tab-content h-100'>
                      <form
                        onSubmit={handleTrack}
                        className='track-and-trace-form'
                      >
                        <div className='row'>
                          <div className='col-lg-12 col-md-12'>
                            <div className='mb-3'>
                              <input
                                type='text'
                                className='form-control'
                                placeholder='Enter Tracking Reference'
                                value={trackingRef}
                                onChange={(e) => setTrackingRef(e.target.value)}
                              />
                            </div>
                          </div>
                          <div className='col-lg-12 col-md-12'>
                            <div className='tw-booking-footer'>
                              <div className='tw-booking-footer-btn'>
                                <button
                                  type='submit'
                                  className='btn-half site-button'
                                >
                                  <span>Track</span>
                                  <em></em>
                                </button>
                              </div>
                              <span className='tw-booking-footer-text'>
                                TRACK
                              </span>
                            </div>
                          </div>
                        </div>
                      </form>
                    </div> */}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}
